var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_8315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.6C6.69782 21.6 2.3999 17.3021 2.3999 12C2.3999 6.69794 6.69782 2.40002 11.9999 2.40002C17.302 2.40002 21.5999 6.69794 21.5999 12C21.5999 17.3021 17.302 21.6 11.9999 21.6ZM11.9999 10.6426L9.28502 7.92674L7.92662 9.28514L10.6425 12L7.92662 14.7149L9.28502 16.0733L11.9999 13.3575L14.7148 16.0733L16.0732 14.7149L13.3573 12L16.0732 9.28514L14.7148 7.92674L11.9999 10.6426Z",
    fill: "#0076CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_8315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon_remove.6dfe27b1959ae5bfd2a00cf5bbbb4951.svg";
export { ForwardRef as ReactComponent };